var _style, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaps = function SvgMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "maps_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".maps_svg__st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.6v15.9M14.5 10.6V.7M13.5 17.3l-5.7 4.1q-.3.15-.6 0L.7 16.8c-.1-.1-.2-.2-.2-.4V1.6c0-.3.2-.5.5-.5.1 0 .2 0 .3.1l6.2 4.4L14.2.8q.3-.15.6 0l6.5 4.6c.1.1.2.2.2.4v4.7",
    className: "maps_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.6c2.2 0 4 1.8 4 4 0 1.8-2.6 5.2-3.6 6.5-.2.2-.5.3-.7.1l-.1-.1c-1-1.3-3.6-4.7-3.6-6.5 0-2.2 1.8-4 4-4",
    className: "maps_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 16.6,
    r: 1.5,
    className: "maps_svg__st0"
  })));
};
export default SvgMaps;